<app-nav titulo="Administración de pagos" descripcion="Aquí podrá ver y descargar los comprobantes de los pagos mensuales que sube el inquilino.">
    <div class="rental-administration">
        <div class="installments-section-container" *ngFor="let section of paymentHistorySections">
            <h2 class="subtitle">
                {{ section.title }}
            </h2>
            <div class="installments section">
                <div class="installment" *ngFor="let installment of installments">
                    <span class="installment-date">
                        {{ utilsService.beautifyDate(installment.fechaVencimientoAlquiler, 'L') }}
                    </span>
                    <div class="installment-status">
                        <div class="installment-status-image" [ngClass]="getStatus(installment, section.documentType).toLowerCase()"></div>
                        <span class="installment-status-text">
                            {{ getStatus(installment, section.documentType).toUpperCase() }}
                        </span>
                    </div>
                    <button mat-icon-button matTooltip="Descargar comprobante de pago subido por el inquilino" class="download-button" [disabled]="!findDocument(installment, section.documentType)" (click)="downloadDocument(findDocument(installment, section.documentType).id)">
                        <mat-icon>download</mat-icon>
                    </button>
                </div>
                <div class="no-payments" *ngIf="!installments?.length">
                    No hay pagos registrados
                </div>
            </div>
        </div>
        <div class="installments-section-container">
            <h2 class="subtitle">
                Pago de servicios
            </h2>
            <div class="installments section">
                <div class="installment" *ngFor="let installment of installments">
                    <span class="installment-date">
                        {{ utilsService.beautifyDate(installment.fechaVencimientoServicios, 'L') }}
                    </span>
                    <div class="installment-status">
                        <div class="installment-status-image" [ngClass]="getStatus(installment, 'COMPROBANTE_PAGO_SERVICIOS').toLowerCase()"></div>
                        <span class="installment-status-text">
                            {{ getStatus(installment, 'COMPROBANTE_PAGO_SERVICIOS').toUpperCase() }}
                        </span>
                    </div>
                    <button mat-icon-button class="download-button" (click)="openServicesPaymentDialog(installment)">
                        <mat-icon>list</mat-icon>
                    </button>
                </div>
                <div class="no-payments" *ngIf="!installments?.length">
                    No hay pagos registrados
                </div>
            </div>
        </div>
    </div>
</app-nav>
